import type { Expression, Filter } from '@fabric-ui/components';
import { mapFilterLeaves } from './map-filter-leaves';

/**
 * Maps every expression while preserving logical operators, metadata, and unchanged branch references.
 *
 * @param source - The filter tree to transform.
 * @param mapper - The transformation applied to each expression.
 * @returns The transformed filter tree, or the original reference when no expression changes.
 *
 * @example
 * ```ts
 * mapFilterExpressions(filter, expression => ({ ...expression, caseInsensitive: true }));
 * ```
 */
export const mapFilterExpressions = (source: Filter, mapper: (expression: Expression) => Expression): Filter =>
  mapFilterLeaves(source, leaf => {
    const expression = mapper(leaf.expression);
    return expression === leaf.expression ? leaf : { ...leaf, expression };
  });
